// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import axios from "axios";
import router from "./router";
import ElementUI from "element-ui";
import store from "@/store/store";
import echarts from "echarts";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/global.css";
import "@/assets/css/base.scss";
// import VideoPlayer from 'vue-video-player'
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import "../node_modules/swiper/swiper.min.css";
// Vue.use(VideoPlayer)
import "@/assets/css/elementChange.css";
import "@/components/publicComponent";
import "lib-flexible/flexible";
import VueContextMenu from "vue-contextmenu";
Vue.use(VueContextMenu);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts;
// !(function() {
//   const handler = setInterval(() => {
//     const before = new Date();
//     debugger;
//     const after = new Date();
//     // 如果不打开调试模式的话,肯定不会大于100
//     const cost = after.getTime() - before.getTime();
//     if (cost > 100) {
//       handlercallback(); // 这个是执行回调
//       clearInterval(handler);
//     }
//   }, 10);
// })();
function handlercallback() {
  window.location.reload();
}
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js